import { useParams } from "react-router-dom";

export const useParsedParam = <T>(
	key: string,
	decorator: (value: string | undefined) => T,
): T => {
	const params = useParams();
	return decorator(params[key]);
};
